<template>
    <section>
        <ScrollObserver
            class="absolute top-24"
            @in-viewport="dropdownSeen = false"
            @not-in-viewport="dropdownSeen = true"
        />
        <div v-if="!settings.is_sourcing_mode" class="w-full flex flex-col at1024:flex-row items-center justify-center at1024:justify-between border-b">
            <Breadcrumbs
                class="block !border-0"
                :crumbs="crumbs"
                h2style="text-base at1024:text-xl"
            />
            <div class="resource-select block w-full at1024:w-88 at1024:pr-8 at1024:mb-0">
                <SeclockMultiselect
                    :option-is-object="true"
                    label-by="display_name"
                    track-by="display_name"
                    value-by="display_name"
                    v-model="selectedManufacturer"
                    :options="manufacturers"
                    :searchable="true"
                    :placeholder="$t('Manufacturers')"
                    :can-clear="false"
                    mode="single"
                    @change="navigateToShow($event)"
                />
            </div>
        </div>
        <Transition v-if="!settings.is_sourcing_mode" name="slide-down">
            <div
                v-if="dropdownSeen"
                class="hidden at1024:flex items-center gap-3 w-full bg-white z-20 fixed border-b px-5 py-6 shadow-md"
                style="top: var(--header-height);"
            >
                <a href="#" class="group">
                    <BaseSvg name="icon-expand-less" class="fill-gray-650 group-hover:fill-red"/>
                </a>
                <h2 class="font-bold text-base">{{ $t("Resources") }}</h2>
            </div>
        </Transition>

<!--        <nav class="border-b flex justify-end gap-8 w-full p-8 mx-auto">-->

<!--        </nav>-->

        <div class="max-w-[730px] mx-auto flex flex-col at1024:flex-row at1024:w-full at1024:max-w-full">
            <aside
                class="overflow-hidden p-4 at1024:p-8 shrink-0 at1024:pr-0 at1024:w-80"
            >
                <h3 class="font-semibold text-xl whitespace-nowrap at1024:text-3xl">
                    {{ $t('New Catalogs') }}
                </h3>

                <CatalogList class="mt-4 pr-4" :resources="newCatalogs" />
            </aside>
            <div class="p-8 w-full">
                <ResourceSearch :manufacturers="manufacturers" :newVideos="newVideos" :searchSettings="searchSettings"/>
            </div>
        </div>
    </section>
</template>

<script setup>
import {
    BaseSvg,
    Breadcrumbs,
    CatalogList,
    ResourceSearch,
    ScrollObserver,
    SeclockMultiselect,
} from "@/Components";
import { ref } from "vue";
import {useUser} from "@/Composables";
import {router} from "@inertiajs/vue3";

const { settings, user } = useUser();
const props = defineProps({
    searchSettings: {
        type: Object,
        required: true,
    },
    crumbs: {
        type: Array,
        required: true,
    },
    manufacturers: {
        type: Array,
        required: true,
    },
    newCatalogs: {
        type: Array,
        required: true,
    },
    newVideos: {
        type: Array,
        required: true,
    },
    pinnedResources: {
        type: Array,
        required: false,
    },
});

const dropdownSeen = ref(false);

const selectedManufacturer = ref('');
const navigateToShow = (event) => router.visit(route('web.catalog.resources.show', event.slug));

</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
    transition: all 0.2s ease-out;
}

.slide-down-leave-to,
.slide-up-enter-from {
    transform: translateY(-100%);
}

.slide-down-enter-from,
.slide-up-leave-to {
    transform: translateY(-100%);
}
</style>
